import React from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import AddZone from './AddZone'

const AddZoneWrapper = () => {
    return (
        <>
            <PageTitle breadcrumbs={[]}>Add Zone</PageTitle>
            <AddZone />
        </>
    )
}

export default AddZoneWrapper